import React from 'react'

import {useStateProviderValue} from '../context/StateProvider'

import {UPDATE_BRANDING_DATA} from '../types'

const Branding=()=> {
	const {state,dispatch} = useStateProviderValue()
    const [brandingData, setBrandingData] = React.useState(state.branding)


    //update right side  data to localstorage // to-do use custom hooks
	React.useEffect(() => {
		setBrandingData(state.branding)
	}, [state])

	//update branding state
	const updateBrandingState=(data:typeof state.branding)=>{
		dispatch({
			type:UPDATE_BRANDING_DATA,
			branding:data
		})
	}


    //handle section main data change
	const handleSectionMainData = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {		
        
        let _brandingData={...brandingData} as any
		_brandingData[event.target.name] = event.target.value	
		updateBrandingState(_brandingData)
	}


    return (
        <div className="branding-page">

                <div className='input-group'>
				<label htmlFor=''>Left background color</label>
				<input
					type='text'
                    onChange={handleSectionMainData}
					name='leftBg'					
					placeholder='#E2DEDF'
                    value={brandingData.leftBg}
                
					
				/>
			</div>
                <div className='input-group'>
				<label htmlFor=''>Right background color</label>
				<input
					type='text'
                    onChange={handleSectionMainData}
					name='rightBg'					
					placeholder='#E2DEDF'
                    value={brandingData.rightBg}
					
				/>
			</div>
                <div className='input-group'>
				<label htmlFor=''>Font color dark</label>
				<input
					type='text'
                    onChange={handleSectionMainData}
					name='fontDark'					
					placeholder='#E2DEDF'
                    value={brandingData.fontDark}
					
				/>
			</div>
                <div className='input-group'>
				<label htmlFor=''>Font color light</label>
				<input
					type='text'
                    onChange={handleSectionMainData}
					name='fontLight'					
					placeholder='#E2DEDF'
                    value={brandingData.fontLight}
					
				/>
			</div>
                <div className='input-group'>
				<label htmlFor=''>Line seperator color</label>
				<input
					type='text'
                    onChange={handleSectionMainData}
					name='lineSeperator'					
					placeholder='#E2DEDF'
                    value={brandingData.lineSeperator}
					
				/>
			</div>

        </div>
    )
}

export default Branding
